<template>
  <div class="ad-message-management">
    <div class="page-header">
      <h2>留言中心</h2>
    </div>

    <!-- 搜索表单 -->
    <el-form :inline="true" :model="searchForm" class="search-form">
      <el-form-item label="广告标题">
        <el-input v-model="searchForm.title" placeholder="请输入广告标题" clearable @keyup.enter.native="handleSearch" />
      </el-form-item>
      <el-form-item label="留言人">
        <el-input v-model="searchForm.user_name" placeholder="请输入留言人昵称" clearable @keyup.enter.native="handleSearch" />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="searchForm.user_mobile" placeholder="请输入留言人手机号" clearable @keyup.enter.native="handleSearch" />
      </el-form-item>
      <el-form-item label="留言内容">
        <el-input v-model="searchForm.content" placeholder="请输入留言内容" clearable @keyup.enter.native="handleSearch" />
      </el-form-item>
      <el-form-item label="来源">
        <el-select v-model="searchForm.access_type" placeholder="请选择" clearable>
          <el-option label="会员免费" :value="1" />
          <el-option label="付费留言" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.is_block" placeholder="请选择" clearable>
          <el-option label="正常" :value="0" />
          <el-option label="已屏蔽" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="留言时间">
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleDateChange"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="messageList" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="ad_title" label="所属广告" min-width="180" show-overflow-tooltip />
      <el-table-column prop="user_name" label="留言人" width="110" />
      <el-table-column prop="user_mobile" label="手机号" width="130" />
      <el-table-column prop="content" label="留言内容" min-width="240" show-overflow-tooltip />
      <el-table-column prop="access_type_name" label="来源" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.access_type == 2 ? 'warning' : 'success'" size="mini">
            {{ scope.row.access_type_name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="is_block" label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_block == 1 ? 'danger' : 'success'" size="mini">
            {{ scope.row.is_block_name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额" width="90">
        <template slot-scope="scope">¥{{ scope.row.amount || 0 }}</template>
      </el-table-column>
      <el-table-column prop="create_time" label="留言时间" width="160" />
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="scope">
          <div class="table-operations">
            <el-button size="mini" type="text" @click="handleView(scope.row)">查看</el-button>
            <el-button
              size="mini"
              type="text"
              :class="scope.row.is_block == 1 ? 'show-btn' : 'block-btn'"
              @click="handleToggleBlock(scope.row)"
            >{{ scope.row.is_block == 1 ? '显示' : '屏蔽' }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.limit"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情对话框 -->
    <el-dialog title="留言详情" :visible.sync="viewDialogVisible" width="700px">
      <div v-if="currentMessage" class="detail-table">
        <div class="detail-row">
          <div class="detail-label">留言ID</div>
          <div class="detail-value">{{ currentMessage.id }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">所属广告</div>
          <div class="detail-value">{{ currentMessage.ad_title }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">广告联系人</div>
          <div class="detail-value">
            {{ currentMessage.ad_contact_name || '-' }}
            <span v-if="currentMessage.ad_contact_phone">
              （{{ currentMessage.ad_contact_phone }}）
            </span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-label">留言人</div>
          <div class="detail-value">{{ currentMessage.user_name }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">留言人手机号</div>
          <div class="detail-value">{{ currentMessage.user_mobile }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">留言内容</div>
          <div class="detail-value detail-pre">{{ currentMessage.content }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">权限来源</div>
          <div class="detail-value">
            <el-tag :type="currentMessage.access_type == 2 ? 'warning' : 'success'" size="mini">
              {{ currentMessage.access_type_name }}
            </el-tag>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-label">留言状态</div>
          <div class="detail-value">
            <el-tag :type="currentMessage.is_block == 1 ? 'danger' : 'success'" size="mini">
              {{ currentMessage.is_block_name }}
            </el-tag>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-label">消耗金额</div>
          <div class="detail-value">¥{{ currentMessage.amount || 0 }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">留言时间</div>
          <div class="detail-value">{{ currentMessage.create_time }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAdMessageList, getAdMessageDetail, changeAdMessageBlock } from '@/api/ad'

export default {
  name: 'AdMessageManagement',
  data() {
    return {
      loading: false,
      messageList: [],
      dateRange: [],
      searchForm: {
        title: '',
        user_name: '',
        user_mobile: '',
        content: '',
        access_type: '',
        is_block: '',
        start_time: '',
        end_time: ''
      },
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      viewDialogVisible: false,
      currentMessage: null
    }
  },
  mounted() {
    this.fetchMessageList()
  },
  methods: {
    async fetchMessageList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          ...this.searchForm
        }
        const response = await getAdMessageList(params)
        this.messageList = response.data.list || []
        this.pagination.total = response.data.total || 0
      } catch (error) {
        console.error('获取留言列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleDateChange(val) {
      this.searchForm.start_time = val && val.length ? val[0] : ''
      this.searchForm.end_time = val && val.length ? val[1] : ''
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchMessageList()
    },
    handleReset() {
      this.searchForm = {
        title: '',
        user_name: '',
        user_mobile: '',
        content: '',
        access_type: '',
        is_block: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.pagination.page = 1
      this.fetchMessageList()
    },
    handleSizeChange(size) {
      this.pagination.limit = size
      this.fetchMessageList()
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchMessageList()
    },
    async handleView(row) {
      try {
        const response = await getAdMessageDetail(row.id)
        this.currentMessage = response.data
        this.viewDialogVisible = true
      } catch (error) {
        console.error('获取留言详情失败:', error)
      }
    },
    handleToggleBlock(row) {
      const isBlocked = Number(row.is_block) === 1
      const tip = isBlocked
        ? '确认恢复显示该留言吗？恢复后用户端可见！'
        : '确认屏蔽该留言吗？屏蔽后用户端不再显示！'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await changeAdMessageBlock(row.id, isBlocked ? 0 : 1)
          this.$message.success(isBlocked ? '已恢复显示' : '已屏蔽')
          this.fetchMessageList()
        } catch (error) {
          console.error('操作失败:', error)
        }
      })
    }
  }
}
</script>

<style scoped>
.ad-message-management {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.search-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.table-operations {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: nowrap;
}

.table-operations .el-button--text {
  padding: 2px 8px;
  font-size: 12px;
  border: none;
  background: none;
}

.table-operations .block-btn {
  color: #f56c6c;
}

.table-operations .block-btn:hover {
  color: #f78989;
  background-color: #fef0f0;
}

.table-operations .show-btn {
  color: #67c23a;
}

.table-operations .show-btn:hover {
  color: #85ce61;
  background-color: #f0f9eb;
}

.dialog-footer {
  text-align: right;
}

.detail-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  min-height: 50px;
  align-items: center;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 500;
  color: #606266;
  width: 150px;
  text-align: right;
  padding: 15px 20px;
  background-color: #fafafa;
  border-right: 1px solid #ebeef5;
  flex-shrink: 0;
  box-sizing: border-box;
}

.detail-value {
  color: #303133;
  word-break: break-word;
  padding: 15px 20px;
  flex: 1;
  box-sizing: border-box;
}

.detail-pre {
  white-space: pre-wrap;
  line-height: 1.7;
}
</style>
